import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl() {
    return `${window.api_url}/member/address_validation`;
  },

  validate(params) {
    return axios.patch(this.baseUrl(), params).catch(handleError);
  },
};
